

// EzLoanUtil is using EzUtils, EzUtil cannot use(import) EzLoanUtil
import EzUtils from "@/utils/EzUtils";
import { AssociatedEntityType } from "@/components/Constants";

export default {

  isAnyAssociatedEntityPresent(ezLoan) {
    if (ezLoan && EzUtils.isNotEmpty(ezLoan.associatedEntities)) {
      return true;
    }
    return false;
  },

  isAnyAssociatedEntityPresentWithType(ezLoan, associatedEntityType) {
    return EzUtils.isNotEmpty(this.getAssociatedEntitiesWithType(
        associatedEntityType,
        ezLoan
    ));
  },

  isAnyCoApplicantAssociatedEntityPresent(ezLoan) {
    return this.isAnyAssociatedEntityPresentWithType(
        ezLoan, AssociatedEntityType.CO_APPLICANT.rawValue
    );
  },

  isAnyGuarantorAssociatedEntityPresent(ezLoan) {
    return this.isAnyAssociatedEntityPresentWithType(
        ezLoan, AssociatedEntityType.GUARANTOR.rawValue
    );
  },

  isAnyVerificationAssociatedEntityPresent(ezLoan) {
    return this.isAnyAssociatedEntityPresentWithType(
        ezLoan, AssociatedEntityType.VERIFICATION.rawValue
    );
  },

  getLoanApplicationType(ezLoan) {
    if (ezLoan && ezLoan.loan && ezLoan.loan.loanApplicationType) {
      return ezLoan.loan.loanApplicationType;
    }

    return null;
  },

  getParentLoanId(ezLoan) {
    const parentLoanAssociatedEntities = this.getAssociatedEntitiesWithType(
        AssociatedEntityType.PARENT_LOAN.rawValue, ezLoan
    );

    if (EzUtils.isNotEmpty(parentLoanAssociatedEntities)) {
      return parentLoanAssociatedEntities[0]["associated_loan_id"];
    }

    return -1;
  },

  getAssociatedEntitiesWithType(
      associatedEntityType,
      ezLoan,
      requireValidLoanId
  ) {
    if (!associatedEntityType || !this.isAnyAssociatedEntityPresent(ezLoan)) {
      return null;
    }

    return this.filterAssociatedEntitiesWithType(
        associatedEntityType,
        ezLoan.associatedEntities,
        requireValidLoanId
    );
  },

  filterAssociatedEntitiesWithType(
      associatedEntityType,
      associatedEntities,
      requireValidLoanId
  ) {
    requireValidLoanId = EzUtils.isBoolean(requireValidLoanId)
        ? requireValidLoanId
        : true;
    if (!associatedEntityType || EzUtils.isEmpty(associatedEntities)) {
      return null;
    }

    const filteredAssociatedEntities = [];

    associatedEntities.forEach(associatedEntity => {
      if (associatedEntity) {
        const associatedEntityType1 = associatedEntity["associated_entity_type"];
        const associatedLoanId = associatedEntity["associated_loan_id"];

        if (associatedEntityType1
            && associatedEntityType === associatedEntityType1
            && (!requireValidLoanId || EzUtils.isValidId(associatedLoanId))
        ) {
          filteredAssociatedEntities.push(associatedEntity);
        }
      }
    })

    return filteredAssociatedEntities;
  }
}
